





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RatingService from '@/evaluations/services/rating-service'
import CandidateJudge from '@/evaluations/models/candidate-judge'
import uniqBy from 'lodash/uniqBy'
import { last } from 'lodash'

@Component
export default class CandidateAssessorsTable extends Vue {
  @Prop({ type: String })
  private evaluationId!: string

  private headers: any[] = []
  private items: any[] = []

  private scores: CandidateJudge[] = []

  private get candidates() {
    const scoreCompetences = this.scores.map((s) => ({
      id: s.candidateId,
      salutation: s.candidateSalutation,
      title: s.candidateTitle,
      lastTitle: s.candidateLastTitle,
      firstName: s.candidateFirstName,
      lastName: s.candidateLastName,
    }))

    return uniqBy(scoreCompetences, 'id')
  }

  private get judges() {
    const scoreJudges = this.scores.map((s) => ({
      id: s.judgeId,
      name: s.judgeName,
    }))

    return uniqBy(scoreJudges, 'id')
  }

  private async setupTable() {
    this.scores = await RatingService.candidateJudge(this.evaluationId)

    this.setupHeader()
    this.createItems()
  }

  private setupHeader() {
    this.headers.push({
      text: '',
      value: 'candidate',
      sortable: false,
    })

    for (const judge of this.judges) {
      this.headers.push({
        text: judge.name,
        value: `judge-${judge.id}`,
        sortable: false,
        align: 'center',
      })
    }
  }

  private createItems() {
    for (const candidate of this.candidates) {
      const item: any = {
        salutation: candidate.salutation,
        title: candidate.title,
        lastTitle: candidate.lastTitle,
        firstName: candidate.firstName,
        lastName: candidate.lastName,
      }

      for (const judge of this.judges) {
        const score = this.scores.find(
          (s) => s.candidateId === candidate.id && s.judgeId === judge.id
        )
        item[`judge-${judge.id}`] = score?.numOfRatings || 0
        item.numOfCompetences = score?.numOfCompetences || 0
      }

      this.items.push(item)
    }
  }

  private ratingAvailable(item: any, judge: any) {
    return item[`judge-${judge.id}`] !== 0
  }

  private discrepancy(item: any, judge: any) {
    return item[`judge-${judge.id}`] - item.targetScore
  }

  private async mounted() {
    await this.setupTable()
  }
}
